import moment from 'moment'
import { ResumePetisSimulationProposalClientResponse } from '../../@types/ResumePetisSimulationProposal'
import { TODAY, useSimulatorStore } from '../../Stores/simulatorStore'
import { useRunPetisSimulationStore } from '../../Stores/useRunPetisSimulationStore'

export const useSimulationHydration = () => {
  const { setInitialDate, setQuoteId } = useSimulatorStore()
  const { setEnabledRunPetisRequest } = useRunPetisSimulationStore()

  const handleSimulationHydration = (
    data: ResumePetisSimulationProposalClientResponse,
  ) => {
    const _initialDateMoment = moment(
      data.processData?.simulationData?.startDate,
    )
    const currentDate = moment(TODAY, 'DD-MM-YYYY')

    setQuoteId(
      data?.processData?.simulationData?.runPetisSimulationClientResponse
        ?.runPetisSimulationResponse?.quoteId || '',
    )

    if (
      _initialDateMoment.isBefore(currentDate) &&
      (data.processData?.documentList || [])?.length === 0 &&
      (data.redirectionStepCode === '10' || data.redirectionStepCode === '20')
    ) {
      setInitialDate(currentDate.format('DD-MM-YYYY'))
      setEnabledRunPetisRequest(true)
    } else {
      setInitialDate(
        moment(data.processData?.simulationData?.startDate).format(
          'DD-MM-YYYY',
        ),
      )
    }
  }

  return {
    handleSimulationHydration,
  }
}
